import { InputLabel, styled } from "@mui/material";

const CustomLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: "14px",
  color: theme.nawy.colors.semantic.text.primary,
  fontWeight: 600,
}));

export default CustomLabel;
